import React from 'react';
import NavigationTabs from '../nav/NavigationTabs';
import Button from '@material-ui/core/Button';
import ButtonContent from '../ButtonContent'
import compose from 'recompose/compose';
import { connect } from "react-redux";
import { fetchAll, changeOrder } from "../../store/actions/brand";
import AlertMessage from '../AlertMessage';
import withAuth from '../../hocs/withAuth';
import { withStyles } from '@material-ui/core/styles';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { COLORS } from '../../styles/colors';


const styles = theme => ({
    root: {
        flexGrow: 1,
      },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        margin: theme.spacing(2, 0),
    },
});
const titleButtonRow = {
    position: 'relative',
}
const titleButton = {
    position: 'absolute',
    top: '-50px',
    right: '0'
}

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const movedItem = result.find((item, index) => index === startIndex);
  const remainingItems = result.filter((item, index) => index !== startIndex);
  const reorderedItems = [
    ...remainingItems.slice(0, endIndex),
    movedItem,
    ...remainingItems.slice(endIndex)
  ];
  return reorderedItems;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? "lightgray" : "white",

  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "#f2f3f4",
  padding: grid,
  width: 800
});

class BrandListing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: '',
      showSuccessMessage: false,
      isChangedOrder: false,
      successMsg: '',
      listing: []
    }
  }

  componentDidMount () {
    this.props.fetchAll();
  }

  static getDerivedStateFromProps(props, state) {
    let updateSate  = null;
    const { listing } = props;
    if (state.listing && state.listing.length) {
      updateSate = {
        listing: state.listing
      }
    } else {
        const filterListing = listing && listing.filter((item)  => {
          return !item.isCorporate
        });
        let updatedListing = filterListing && filterListing.map((item, index) => {
            return {
                _id: item._id,
                displayName: item.displayName,
                order: item.order
            }
        })
        updatedListing.sort(function(a, b) {
          return a.order - b.order;
        });
        updateSate = {
            listing: updatedListing
        }
    }
    return updateSate;
  }

  submitChangeOrder() {
    this.props.removeError();
    const listing = this.state.listing;
    const order = listing.map((item, index) =>  {
        return {
            _id: item._id,
            order: index,
            name: item.displayName
        }
    });
    const { changeOrder } = this.props;
    changeOrder({ order }).then((response) => {
      this.setState({
        showErrorMessage: true,
        successMsg: response.message,
        isChangedOrder: false
      })
    })
  }

  renderBrandListing() {
      const {listing} = this.state;
      let data = [];
      if (listing && listing.length === 0) {
        return (
          <div style={{
            color:COLORS.red,
            height:200,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}><strong>No Brand Found.</strong></div>
        );
      }
      if (listing && listing.length > 0) {
        data = (
          <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                  >
                    {listing.map((item, index) => (
                      <Draggable key={item._id} draggableId={item._id} index={index} >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            {item.displayName}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
          </Droppable>
        </DragDropContext>
        )
      }
      return data;
  }

  onDragEnd = (result) =>  {
    if (!result.destination) {
      return;
    }
    const items = reorder(
      this.state.listing,
      result.source.index,
      result.destination.index
    );

    this.setState({
      isChangedOrder: true,
      listing: items,
    });
  }

  render() {
    const { errors } = this.props;
    return (
      <div>
        <NavigationTabs
          title={`Manage Brands`}
          set={'manageBrands'}
          subtitle={`Change Order`}
          activeRoute={'/manageBrands/listing'}/>
        <div style={titleButtonRow}>
          {
            this.state.showErrorMessage ? (
              <AlertMessage
                subject="Channels Order Changed!"
                body={this.state.successMsg}
                icon={['far','check-square']}
                />
            ) : null
          }
          {errors.message && <div className="alert alert-danger">{errors.message}</div>}
          <div style={titleButton}>
                  <Button
                      onClick={() => { this.submitChangeOrder() }}
                      disabled={!this.state.isChangedOrder}
                      variant="contained"
                      color="primary">
                      <ButtonContent
                        text="Save"
                        icon="chevron-right" />
                  </Button>
        </div>
          {this.renderBrandListing()}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    listing: state.brand && state.brand.brandListing || [],
    errors: state.errors
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchAll: () => {
      return dispatch(fetchAll(false, false));
    },
    changeOrder: (data) => {
        return dispatch(changeOrder(data))
    }
  }
}

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
  )(withAuth(BrandListing));




// WEBPACK FOOTER //
// ./src/components/manageBrands/BrandListing.js